import { AlertTriangle } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

interface FieldErrorProps {
  error?: string;
  isVisible?: boolean;
}

export function FieldError({ error, isVisible = true }: FieldErrorProps) {
  return (
    <AnimatePresence>
      {error && isVisible && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.2 }}
          className="flex items-center gap-2 text-sm text-red-400 mt-1 px-1"
        >
          <AlertTriangle className="w-3 h-3 flex-shrink-0" />
          <span>{error}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}